<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: {{$t('AddNew')}} Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">

    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? $t('AddNew'): $t('Update') }} {{$t('Item')}}</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>

    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">

      <div class="p-6">

        <!-- NAME -->
        <!-- <vs-input label="Part1" v-model="Part1" class="mt-5 w-full" name="Part1" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('Part1')">{{ errors.first('Part1') }}</span> 

        <vs-input label="Part2" v-model="Part2" class="mt-5 w-full" name="Part2" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('Part2')">{{ errors.first('Part2') }}</span>   

        <vs-input label="Part3" v-model="Part3" class="mt-5 w-full" name="Part3"  v-show="Part2" />
        <span class="text-danger text-sm" v-show="errors.has('Part3')">{{ errors.first('Part3') }}</span> 

        <vs-input label="Part4" v-model="Part4" class="mt-5 w-full" name="Part4"  v-show="Part3" />
        <span class="text-danger text-sm" v-show="errors.has('Part4')">{{ errors.first('Part4') }}</span>     -->

           <div class=" vx-col flex-1" style="padding-left:5px">
              <p>Part1</p>
          <v-select
            label="Name"
            v-model="Part1"
            :options="GenerateCodeItems" 
            class="w-full"
            :reduce="Code => Code.ID"
            v-if="(Part1=='1'||Part1=='2'||Part1=='3'||Part1==''||Part1==null)"
          />
                      <!-- <vs-select class="mt-5 w-full" label="Part1 " v-model="Part1"  v-if="(Part1=='1'||Part1=='2'||Part1=='3'||Part1==''||Part1==null)">
                                <vs-select-item :key="index" :value="item.ID" :text="item.Name" v-for="(item,index) in GenerateCodeItems" />
                      </vs-select> -->
                      <vs-input  v-model="Part1" class="mt-5 w-full" name="Part1" v-validate="'required'" v-if="!(Part1=='1'||Part1=='2'||Part1=='3'||Part1==''||Part1==null)"/>
                    <span class="text-danger text-sm"  v-show="errors.has('Part1')">{{ errors.first('Part1') }}</span>

                </div>
               <div class=" vx-col flex-1" style="padding-left:5px">
                     <p>Part2</p>
          <v-select
            label="Name"
            v-model="Part2"
            :options="GenerateCodeItems" 
            class="w-full"
            :reduce="value => value.ID"
            v-if="(Part2=='1'||Part2=='2'||Part2=='3'||Part2==''||Part2==null)"
          />
                      <!-- <vs-select class="mt-5 w-full" label="Part2 " v-model="Part2" v-if="(Part2=='1'||Part2=='2'||Part2=='3'||Part2==''||Part2==null)">
                                <vs-select-item :key="index" :value="item.ID" :text="item.Name" v-for="(item,index) in GenerateCodeItems" />
                      </vs-select> -->
                      <vs-input  v-model="Part2" class="mt-5 w-full" name="Part2" v-validate="'required'" v-if="!(Part2=='1'||Part2=='2'||Part2=='3'||Part2==''||Part2==null)"/>
                    <span class="text-danger text-sm"  v-show="errors.has(' Part2')">{{ errors.first('Part2') }}</span>

                </div>
                   <div class=" vx-col flex-1" style="padding-left:5px" v-show="Part2">
           <p>Part3</p>
          <v-select
            label="Name"
            v-model="Part3"
            :options="GenerateCodeItems" 
            class="w-full"
            :reduce="value => value.ID"
            v-if="(Part3=='1'||Part3=='2'||Part3=='3'||Part3==''||Part3==null)"
          />
                      <!-- <vs-select class="mt-5 w-full" label="Part3 " v-model="Part3" v-if="(Part3=='1'||Part3=='2'||Part3=='3'||Part3==''||Part3==null)">
                                <vs-select-item :key="index" :value="item.ID" :text="item.Name" v-for="(item,index) in GenerateCodeItems" />
                      </vs-select> -->
                      <vs-input  v-model="Part3" class="mt-5 w-full" name="Part3" v-validate="'required'" v-if="!(Part3=='1'||Part3=='2'||Part3=='3'||Part3==''||Part3==null)"/>
                    <span class="text-danger text-sm"  v-show="errors.has(' Part3')">{{ errors.first('Part3') }}</span>

                </div>
                   <div class=" vx-col flex-1" style="padding-left:5px" v-show="Part3">
                        <p>Part4</p>
          <v-select
            label="Name"
            v-model="Part4"
            :options="GenerateCodeItems" 
            class="w-full"
            :reduce="value => value.ID"
           v-if="(Part4=='1'||Part4=='2'||Part4=='3'||Part4==''||Part4==null)"
          />
                      <!-- <vs-select class="mt-5 w-full" label="Part4" v-model="Part4" v-if="(Part4=='1'||Part4=='2'||Part4=='3'||Part4==''||Part4==null)">
                                <vs-select-item :key="index" :value="item.ID" :text="item.Name" v-for="(item,index) in GenerateCodeItems" />
                      </vs-select> -->
                      <vs-input  v-model="Part4" class="mt-5 w-full" name="Part4" v-validate="'required'" v-if="!(Part4=='1'||Part4=='2'||Part4=='3'||Part4==''||Part4==null)"/>
                    <span class="text-danger text-sm"  v-show="errors.has(' Part4')">{{ errors.first('Part4') }}</span>

                </div>
                    <div class=" vx-col flex-1" style="padding-left:5px"> <!-- fixed type-->
              <vs-input :label="$t('Seperator')" v-model="SeperatorText" class="w-full" name="SeperatorText"/>
                      <span class="text-danger text-sm" v-show="errors.has('SeperatorText')">{{ errors.first('SeperatorText') }}</span>
                   </div>
                   
      </div>

    </VuePerfectScrollbar>

    <div class=" vx-row flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-2" @click="submitData" :disabled="!isFormValid">{{$t('Submit')}}</vs-button>
      <vs-button class="mr-2" type="border" color="danger" @click="isSidebarActiveLocal = false">{{$t('Cancel')}}</vs-button> 
      <vs-button class="mr-2" type="border" @click="initValues">{{$t('Reset')}}</vs-button>
    </div>

  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moduleGenerateCode from "@/store/settings/generateCode/moduleGenerateCode.js";
import vSelect from 'vue-select'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },

  watch: {
    isSidebarActive(val) { 
      if (!val) return;
      if (Object.entries(this.data).length === 0) {
        this.initValues();
        this.$validator.reset();
      } else {
        let { ID, Part1 ,Part2,Part3,Part4,FinalCode ,GenerateCodeTypeID,SeperatorText} = JSON.parse( 
          JSON.stringify(this.data)
        );
        debugger;
        this.ID = ID;
        this.Part1 = this.isNumber(Part1)? parseInt(Part1):Part1;
        this.Part2 = this.isNumber(Part2)? parseInt(Part2):Part2;
        this.Part3 = this.isNumber(Part3)? parseInt(Part3):Part3;
        this.Part4 = this.isNumber(Part4)? parseInt(Part4):Part4;
        this.FinalCode = FinalCode;
        this.GenerateCodeTypeID=GenerateCodeTypeID;
        this.SeperatorText =SeperatorText;
       // this.initValues();
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.Id, this.Name, this.dataGenerateCode, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },

  data() {
    return {
      ID: null,
      Part1: "",
      Part2: "",
      Part3: "",
      Part4: "",
      FinalCode:"",
      GenerateCodeTypeID:null,
      SeperatorText : "",
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    };
  },

  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid() {
      return !this.errors.any() && this.Part1!=""  && this.SeperatorText != "";
    },
    GenerateCodeItems() {
      debugger;
      return this.$store.state.GenerateCodeList.GenerateCodeItems;
    }
  },

  methods: {
     isNumber(n) { return !isNaN(parseFloat(n)) && !isNaN(n - 0) },
    initValues() {
      
      this.Part1 = "";
      this.Part2 = "";
      this.Part3 = "";
      this.Part4 = "";
      this.SeperatorText = "";
    },

    submitData() {
      debugger;
      this.$validator.validateAll().then(result => {
            if (this.Part1 == "1")
            {
                 this.FinalCode = "Year";
            }
            else if(this.Part1=="2"){
                   this.FinalCode = "ShortYear";
            }
             else if(this.Part1=="3"){
                   this.FinalCode = "Month";
            }
            else{
              this.FinalCode= this.Part1;
            }
        if(this.Part2!="")
         {
            if (this.Part2 == "1")
            {
                 this.FinalCode = this.FinalCode+this.SeperatorText+ "Year";
            }
            else if(this.Part2=="2"){
                   this.FinalCode =this.FinalCode+this.SeperatorText+ "ShortYear";
            }
            else if(this.Part2=="3"){
                   this.FinalCode =this.FinalCode+this.SeperatorText+ "Month";
            }
            else {
              this.FinalCode= this.FinalCode+this.SeperatorText+this.Part2;
            }
        }
          // this.FinalCode = this.Part1 +'-' +this.Part2+'-';
           if(this.Part3!="")
           {
                  if (this.Part3 == "1")
                  {
                      this.FinalCode = this.FinalCode+this.SeperatorText+ "Year";
                  }
                  else if(this.Part3=="2"){
                        this.FinalCode =this.FinalCode+this.SeperatorText+ "ShortYear";
                  }                  
                  else if(this.Part3=="3"){
                        this.FinalCode =this.FinalCode+this.SeperatorText+ "Month";
                  }
                  else 
                  {
                    this.FinalCode= this.FinalCode+this.SeperatorText+this.Part3;
                  }
           }
           if(this.Part4!="")
             {
                 if (this.Part4 == "1")
                  {
                      this.FinalCode = this.FinalCode+this.SeperatorText+ "Year";
                  }
                  else if(this.Part4=="2"){
                        this.FinalCode =this.FinalCode+this.SeperatorText+ "ShortYear";
                  }
                  else if(this.Part3=="3"){
                        this.FinalCode =this.FinalCode+this.SeperatorText+ "Month";
                  }
                  else{
                    this.FinalCode= this.FinalCode+this.SeperatorText+this.Part4;
                  }
            }
          
             if (result) {
          const obj = {
            ID: this.ID,
           Part1: this.Part1 ,
           Part2: this.Part2 ,
           Part3: this.Part3 ,
           Part4: this.Part4 ,
           FinalCode:this.FinalCode,
           GenerateCodeTypeID :this.GenerateCodeTypeID,
           SeperatorText : this.SeperatorText,
          };
          if (this.ID !== null && this.ID >= 0) {
            this.$store.dispatch("GenerateCodeList/updateItem", obj).then(()=>{
                 this.$store.dispatch("GenerateCodeList/fetchDataListItems");
            }).catch(err => {
              console.error(err);
            });
         
          } else {
            delete obj.ID;
            obj.popularity = 0;
            this.$store.dispatch("GenerateCodeList/addItem", obj).catch(err => {
              console.error(err);
            });
          }

          this.$emit("closeSidebar");
          this.initValues();
          
        }
      });
    },

   
  },

  created() {
    if (!moduleGenerateCode.isRegistered) {
      this.$store.registerModule("GenerateCodeList", moduleGenerateCode);
      moduleGenerateCode.isRegistered = true;
    }
    this.$store.dispatch("GenerateCodeList/getGenerateCodeItems");
  },
  components: {
    VuePerfectScrollbar,
    vSelect
  }
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  height: calc(100% - 4.3rem);
}
</style>
